import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { getPlanSignupStatus } from '../../../../services/PublicPlanSignupService';
import './ClientTabBar.css';

// Resultado por empresa: a barra aparece em várias telas e não precisa consultar de novo a cada uma.
const planSignupCache = {};

/**
 * Barra de abas fixa no rodapé do ambiente do cliente, no estilo de um aplicativo: Agendar,
 * Meus agendamentos, Planos (quando a empresa oferece) e Parceiros. Fica em todas as telas públicas do cliente para ele nunca precisar
 * de um link avulso para trocar de área.
 * A vitrine continua acessível mesmo quando ainda não há parceiros cadastrados.
 */
const ClientTabBar = ({ companyUuid, onBookingTab }) => {
    // A barra ocupa o rodapé: a página ganha espaço embaixo e o rodapé fixo do agendamento sobe.
    useEffect(() => {
        document.documentElement.classList.add('has-client-tabbar');
        return () => document.documentElement.classList.remove('has-client-tabbar');
    }, []);

    // A aba de planos só existe quando a empresa tem provedor de pagamento e plano contratável.
    const [planSignupEnabled, setPlanSignupEnabled] = useState(Boolean(planSignupCache[companyUuid]));
    useEffect(() => {
        if (planSignupCache[companyUuid] !== undefined) return;
        getPlanSignupStatus(companyUuid)
            .then(({ data }) => {
                planSignupCache[companyUuid] = Boolean(data.enabled);
                setPlanSignupEnabled(planSignupCache[companyUuid]);
            })
            // Sem resposta a aba simplesmente não aparece; nada mais depende dela.
            .catch(() => {});
    }, [companyUuid]);

    const tabs = [
        { to: `/booking/${companyUuid}`, icon: 'fa-solid fa-calendar-plus', label: 'Agendar', end: true, onClick: onBookingTab,
            // O fluxo de agendamento tem etapas na própria rota (/booking/:empresa/:etapa).
            isActive: (path) => path.startsWith(`/booking/${companyUuid}`) && !path.endsWith('/my-appointments') && !path.endsWith('/partners') && !path.endsWith('/plans') },
        { to: `/booking/${companyUuid}/my-appointments`, icon: 'fa-solid fa-calendar-check', label: 'Meus horários', accessibleLabel: 'Meus agendamentos' },
        planSignupEnabled && { to: `/booking/${companyUuid}/plans`, icon: 'fa-solid fa-crown', label: 'Planos' },
        { to: `/booking/${companyUuid}/partners`, icon: 'fa-solid fa-gift', label: 'Parceiros' }
    ].filter(Boolean);

    return (
        <nav className="client-tabbar" aria-label="Navegação principal">
            {tabs.map((tab) => (
                <NavLink key={tab.to} to={tab.to}
                    aria-label={tab.accessibleLabel || tab.label}
                    onClick={tab.onClick ? (event) => { event.preventDefault(); tab.onClick(); } : undefined}
                    className={({ isActive }) => `client-tabbar__item ${(tab.isActive ? tab.isActive(window.location.pathname) : isActive) ? 'is-active' : ''}`}>
                    <i className={tab.icon}></i>
                    <span>{tab.label}</span>
                </NavLink>
            ))}
        </nav>
    );
};

export default ClientTabBar;
